class ShadeFinderQuizStart extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    const startSectionEl = document.querySelector('shade-finder-quiz-start')
    const startQuizBtn = document.querySelector('[data-start-shadefinder-quiz-trigger]')

    startQuizBtn.addEventListener('click', () => {
      startSectionEl.classList.remove('is-active')

      const skintoneSectionEl = document.querySelector('shade-finder-quiz-skintone')

      skintoneSectionEl.classList.add('is-active')
    })

    const findationButton = this.els?.findation?.element
    const findationApiKey = findationButton?.getAttribute('data-findation-api-key')
    const isDemoMode = findationButton?.getAttribute('data-findation-demo-mode') === 'true'

    window.Findation = window.Findation || {};
    Findation.init(
      document.getElementById("findation-widget-button"),
        findationApiKey,
      {
        isDemoMode: isDemoMode,
        searchSetLookupReference: "shade-finder-products"
      }
    )

    if (findationButton) {
      this.listeners.add(findationButton, 'click', () => {
        Findation.openWidget()
      })
    }

    Findation.widgetEmbedded = function() {
      findationButton.removeAttribute('aria-hidden')
    }
  }
}

if (!customElements.get('shade-finder-quiz-start')) {
  customElements.define('shade-finder-quiz-start', ShadeFinderQuizStart)
}
